@if (lorenzFormGroup && lorenzFormControl && (isEnabled() || hasLockedPreview())) {

	<div class="outer-wrapper"
		 [formGroup]="lorenzFormGroup">

		<div class="control-wrapper">

			<div class="control">

				<div class="image-box"
					 [class.focused]="isFocused()"
					 [class.has-locked-preview]="hasLockedPreview()"

					 role="button"
					 tabindex="0"
					 aria-label="Bild einfügen oder ablegen"

					 (focus)="onFocus()"
					 (blur)="onBlur()"
					 (paste)="onPaste($event)">

					<ng-container *ngIf="preview(); else empty">
						<img [src]="preview()" alt="Vorschaubild" />
					</ng-container>

					<ng-template #empty>
						<div class="hint-box">{{ isFocused() ? 'Bild jetzt einfügen mit STRG+V' : 'Hier klicken um ein Bild einzufügen' }}</div>
					</ng-template>
				</div>

				@if (isEnabled()) {

					<button mat-icon-button class="delete mat-action-delete"
							title="{{ 'Screenshot löschen' | translate }}"
							[disabled]="deleteButtonDisabled"
							(click)="clear($event)">
						<mat-icon>delete</mat-icon>
					</button>

				}

			</div>

		</div>

	</div>


	<lib-form-validity-dot [control]="lorenzFormControl" />

}